<template>
  <div>
    <b-row>
      <b-col sm="12" md="12">
        <b-card no-body>
          <b-card-header>
            <h3 class="float-left"><i class='fa fa-bank'></i> ICICI Payout Withdraw Detail for ADHoc</h3>
            <div class="float-right">
              <b-button variant="info" @click="exportCSV" v-if="checkAccessPrivilege('Payment.Records.ICICI.Payout.Export')">Export</b-button>&nbsp;&nbsp;
              <b-button variant="info" @click="downloadSample" v-if="checkAccessPrivilege('Payment.Records.ICICI.Payout.BatchUpload')">Excel Sample Download</b-button>&nbsp;&nbsp;
              <b-button variant="success" @click="showBatchUploadModal" v-if="checkAccessPrivilege('Payment.Records.ICICI.Payout.BatchUpload')">Batch Upload</b-button>&nbsp;&nbsp;
            </div>
          </b-card-header>
          <b-card-body>
            <b-table :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage">
            </b-table>
            <nav>
              <b-pagination :total-rows="getRowCount(items)" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
            </nav>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <b-modal ref="showBatchUploadModal" size="lg" centered header-bg-variant="primary" hide-footer title="Batch Upload Withdraw Data">
      <div class="mb-3" v-if="showForm">
        <b-row>
          <b-col sm="12">
            <label class="mr-sm-2" for="debitNumber">Debit Account Number </label>
            <b-input id="debitNumber" type="text" placeholder="" v-model.trim="form.debitNumber"></b-input>
            <div v-if="$v.form.debitNumber.$error">
              <div class="invalid-feedback d-block" v-if="!$v.form.debitNumber.required">Please Enter Debit Number.</div>
              <div class="invalid-feedback d-block" v-if="!$v.form.debitNumber.numeric">Debit Number should be number.</div>
              <div class="invalid-feedback d-block" v-if="!$v.form.debitNumber.minLength">Debit Number should be exaclty 12 digit</div>
              <div class="invalid-feedback d-block" v-if="!$v.form.debitNumber.maxLength">Debit Number should be exaclty 12 digit</div>
            </div>
          </b-col>
          <b-col sm="12">
            <label for="groupId">Upload File</label>
            <div class="custom-file">
              <input type="file" class="custom-file-input" id="customFile" @change="handleFileChange">
              <label class="custom-file-label" for="customFile">{{ form.batchUpload.uploadedFileName }}</label>
            </div>
            <small id="passwordHelpBlock" class="form-text text-muted">
              Suppported extension (.xlsx | .xls)
            </small>
            <div v-if="$v.form.batchUpload.uploadFile.$error">
              <div class="invalid-feedback d-block" v-if="!$v.form.batchUpload.uploadFile.required">Please upload file.</div>
              <div class="invalid-feedback d-block" v-if="!$v.form.batchUpload.uploadFile.fileType">Invalid File Format. Must be (.xlsx | .xls)</div>
            </div>
          </b-col>
        </b-row>
      </div>
      <b-button variant="success" @click="submitBatchUpload" :disabled="$v.form.batchUpload.$error">Upload</b-button>
      <b-button variant="outline-danger" @click="cancelBatchUploadModal">Cancel</b-button>
    </b-modal>
  </div>
</template>

<script>
  import VueNotifications from 'vue-notifications'
  import {Events} from '../../../../events.js'
  const {required, numeric, minLength, maxLength} = require('vuelidate/lib/validators')
  const moment = require('moment-timezone')
  export default {
    name: 'member-bank-ifsc-record-table',
    props: {
      caption: {
        type: String,
        default: 'Table'
      },
      hover: {
        type: Boolean,
        default: false
      },
      striped: {
        type: Boolean,
        default: false
      },
      bordered: {
        type: Boolean,
        default: false
      },
      small: {
        type: Boolean,
        default: false
      },
      fixed: {
        type: Boolean,
        default: false
      }
    },
    data: () => {
      return {
        items: [],
        showForm: false,
        fields: [
          {key: 'TransactionType', label: 'Transaction Type'},
          {key: 'DebitNumber', label: 'Debit Account Number'},
          {key: 'IFSC', label: 'IFSC Number'},
          {key: 'AccountNumber', label: 'Beneficiary Account Number'},
          {key: 'AccountName', label: 'Beneficiary Name'},
          {key: 'WithdrawAmount', label: 'Amount'},
          {key: 'OrderNumber', label: 'Remarks for Beneficiary & Remarks for Client'},
          {key: 'Remarks', label: 'Remarks'}
        ],
        form: {
          debitNumber: '',
          batchUpload: {
            uploadedFileName: 'Choose File',
            uploadFile: ''
          }
        },
        currentPage: 1,
        perPage: 50
      }
    },
    validations: {
      form: {
        debitNumber: {
          required,
          numeric,
          minLength: minLength(12),
          maxLength: maxLength(12)
        },
        batchUpload: {
          uploadFile: {
            required,
            fileType: function (e) {
              if (!e) return true
              let type = e.name ? e.name.split('.').reverse()[0] : ''
              return (type !== '' && (type === 'xlsx' || type === 'xls'))
            }
          }
        }
      }
    },
    methods: {
      handleFileChange (e) {
        this.form.batchUpload.uploadedFileName = e.target.files[0].name
        this.form.batchUpload.uploadFile = e.target.files[0]
      },
      getRowCount (items) {
        return items.length
      },
      async exportCSV () {
        try {
          let exportData = this.items
          if (exportData.length === 0) {
            Events.$emit('alert', VueNotifications.types.error, 'Error', 'Please upload export sheet first')
            return
          }
          let { data } = await this.$http.post(this.API_ENDPOINT + '/payment/record/withdraw/icici/payout/export', {
            data: exportData
          }, { responseType: 'blob', headers: { 'Content-Type': 'application/json' } })
          let url = window.URL.createObjectURL(new Blob([ data ]))
          let link = document.createElement('a')
          link.href = url
          link.setAttribute('download', `ICICI_Withdraw_Detail_${moment().tz('Asia/Taipei').format('YYYYMMDDHHMMSS')}.csv`)
          link.click()
        } catch (err) {
          console.log('this is an error ', err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        }
      },
      async downloadSample () {
        try {
          let { data } = await this.$http.get(this.API_ENDPOINT + '/payment/record/withdraw/request/list/sample', { responseType: 'blob', headers: { 'Content-Type': 'application/json' } })
          let url = window.URL.createObjectURL(new Blob([ data ]))
          let link = document.createElement('a')
          link.href = url
          link.setAttribute('download', `ICICI_Withdraw_Detail_Batch_Upload_Sample.csv`)
          link.click()
          alert('Change the file extension to .xlsx or .xls')
        } catch (err) {
          console.log('this is an error ', err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        }
      },
      async submitBatchUpload () {
        try {
          this.$v.form.$touch()
          if (this.$v.form.$error) {
            return true
          } else {
            let data = new FormData()
            data.append('debitNumber', this.form.debitNumber)
            data.append('file', this.form.batchUpload.uploadFile)
            data.append('operator', this.operator)

            let result = await this.$http.post(this.API_ENDPOINT + '/payment/record/withdraw/icici/payout', data)
            this.cancelBatchUploadModal()
            this.items = result.data
          }
        } catch (error) {
          console.log('this is an error', error)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        }
      },
      showBatchUploadModal () {
        this.showForm = true
        this.$refs.showBatchUploadModal.show()
      },
      cancelBatchUploadModal () {
        this.form.debitNumber = ''
        this.form.batchUpload.uploadedFileName = 'Choose File'
        this.form.batchUpload.uploadFile = ''
        this.showForm = false
        this.$v.form.batchUpload.$reset()
        this.$refs.showBatchUploadModal.hide()
      },
      checkAccessPrivilege (module) {
        if (!module) return true
        return this.PRIVILEGE.includes(module)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/payment/records/ICICIPayout/ICICIPayoutTable.vue